import React from 'react';
import HeatMapCardList from 'recommendationsNew/components/heatMap/heatMapCards/heatMapCardList.jsx';
import HeatMapDimensions from 'recommendationsNew/components/heatMap/heatMapDimensions.jsx';
import { useHeatMapContext } from 'recommendationsNew/components/heatMap/contexts/heatMapContext.jsx';
import { useRecommendationsNewContext } from 'recommendationsNew/contexts/recommendationsNewContext.jsx';
import { useRootStore } from 'app/contexts/RootStoreContext.jsx';
import HeatMapFilters from 'recommendationsNew/components/heatMap/heatMapFilters/mainFilters/heatMapFilters.jsx';
import styles from 'recommendationsNew/components/heatMap/heatMap.module.scss';

const WasteMapContent = ({ withOverrideApiKey, currentOverrideCurrency }) => {
  const {
    heatMapGroupByOptions: groupByOptionsContext,
    setHeatMapGroupByOptions,
    isHeatMapClosed,
  } = useHeatMapContext();
  const { isDashboardPanel } = useRecommendationsNewContext();
  const { usersStore } = useRootStore();

  const optionClicked = (option) => {
    const optionClicked = groupByOptionsContext?.find((obj) => obj.id === option.id);
    if (!optionClicked) {
      setHeatMapGroupByOptions([...groupByOptionsContext, { ...option, default: true }]);
    } else {
      setHeatMapGroupByOptions([...groupByOptionsContext.filter((obj) => obj.id !== option.id)]);
    }
  };
  return (
    <>
      <HeatMapFilters usersStore={usersStore} />
      {!isHeatMapClosed ? (
        <div className={styles.content}>
          <div className={styles.heatMapContent}>
            <HeatMapCardList onCardClose={optionClicked}
                             withOverrideApiKey={withOverrideApiKey}
                             currentOverrideCurrency={currentOverrideCurrency} />
            {!isDashboardPanel &&
              <HeatMapDimensions withOverrideApiKey={withOverrideApiKey} onGroupByOptionClick={optionClicked} />}
          </div>
        </div>
      ) : (
        <div />
      )}
    </>
  );
};

export default WasteMapContent;
